import HeroTabs from './HeroTabs.js';
export default HeroTabs;